// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import vueSocket from 'vue-socket.io-extended'
import socket from 'socket.io-client'

Vue.use(vueSocket, socket('https://e988-220-84-34-186.ngrok.io', {withCredentials: true}))

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js